import { useEffect, useRef } from 'react';

// Hook that will execute a function in the useEffect after the
// initial mount, e.g. not on initial mount.
const useDidUpdateEffect = (fn, inputs) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      fn && fn();
    } else {
      didMountRef.current = true;
    }
  }, inputs);
};

export default useDidUpdateEffect;